document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-action="scroll-next-section"]');
  if (!button) return;
  button.closest('.shopify-section')?.nextElementSibling?.scrollIntoView({ block: 'start', behavior: 'smooth' });
});

const backToTop = document.querySelector('[data-action="back-to-top"]');
if (backToTop) {
  backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  const toggleBackToTop = () => backToTop.classList.toggle('is-visible', window.scrollY > 600);
  window.addEventListener('scroll', toggleBackToTop, { passive: true });
  toggleBackToTop();
}

// Flèche du hero : atterrissage exact du panneau suivant sous le header
document.addEventListener('click', (event) => {
  const heroNext = event.target.closest('.slideshow__next-section-button');
  if (!heroNext) return;
  event.preventDefault();
  event.stopPropagation();
  const section = heroNext.closest('.shopify-section')?.nextElementSibling;
  if (!section) return;
  const header = document.querySelector('.shopify-section--header');
  const offset = header ? header.getBoundingClientRect().height : 0;
  const rect = section.getBoundingClientRect();
  const vh = window.innerHeight;
  // Cale le panneau plein écran : bas aligné en bas de fenêtre (chevron visible)
  // si plus grand que la zone sous le header, sinon haut calé sous le header.
  const topUnderHeader = rect.top + window.scrollY - offset;
  const bottomAligned = rect.top + window.scrollY + rect.height - vh;
  const top = rect.height > vh - offset ? Math.max(topUnderHeader, bottomAligned) : topUnderHeader;
  window.scrollTo({ top, behavior: 'smooth' });
}, true);

// Diaporama auto de la section La boutique : fondu croisé toutes les 4,5 s
const boutiqueSlides = document.querySelectorAll('.mmwt-panel .multiple-media-with-text__media-wrapper > *');
if (boutiqueSlides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let boutiqueIndex = 0;
  boutiqueSlides[0].classList.add('is-active');
  setInterval(() => {
    boutiqueSlides[boutiqueIndex].classList.remove('is-active');
    boutiqueIndex = (boutiqueIndex + 1) % boutiqueSlides.length;
    boutiqueSlides[boutiqueIndex].classList.add('is-active');
  }, 4500);
} else if (boutiqueSlides.length) {
  boutiqueSlides[0].classList.add('is-active');
}

// Newsletter : parallaxe flottant doux du panneau caramel.
// Transform pur : la place occupée dans le flux ne change pas, les écarts
// entre sections restent stables ; l'amplitude (20px) reste bien en deçà
// des marges du bloc (6rem), aucun chevauchement possible.
const newsletterPanel = document.querySelector('.shopify-section--newsletter .section-spacing');
if (newsletterPanel && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let newsletterTicking = false;
  const newsletterFloat = () => {
    newsletterTicking = false;
    const rect = newsletterPanel.getBoundingClientRect();
    const vh = window.innerHeight;
    if (rect.bottom < 0 || rect.top > vh) return;
    // -1 (panneau sorti par le haut) à 1 (entré par le bas), 0 au centre
    const progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
    newsletterPanel.style.transform = `translateY(${(progress * 20).toFixed(1)}px)`;
  };
  const requestNewsletterFloat = () => {
    if (!newsletterTicking) {
      newsletterTicking = true;
      requestAnimationFrame(newsletterFloat);
    }
  };
  window.addEventListener('scroll', requestNewsletterFloat, { passive: true });
  window.addEventListener('resize', requestNewsletterFloat, { passive: true });
  newsletterFloat();
}

// Popup d'inscription : la balise am-signup-card est un alias du composant
// newsletter-popup du thème, sous un nom neutre que les filtres des bloqueurs
// de pub ne ciblent pas.
customElements.whenDefined('newsletter-popup').then(() => {
  if (!customElements.get('am-signup-card')) {
    customElements.define('am-signup-card', class extends customElements.get('newsletter-popup') {});
  }
});

// L'intro du hero attend la fermeture du popup, puis se rejoue en entier
// (redémarrage explicite, robuste même si le popup est refermé par
// l'éditeur de thème ou masqué de force par un bloqueur de pub).
const signupCardEl = document.querySelector('am-signup-card');
const heroIntroEls = document.querySelectorAll(
  '.shopify-section--slideshow:first-child .content-over-media > picture img,' +
  ' .shopify-section--slideshow:first-child .slideshow__slide-content .h1,' +
  ' .shopify-section--slideshow:first-child .slideshow__slide-content .h6,' +
  ' .shopify-section--slideshow:first-child .slideshow__slide-content .link,' +
  ' .shopify-section--slideshow:first-child .slideshow__next-section-button'
);
if (signupCardEl && heroIntroEls.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  // Même logique que le composant du thème : le popup va-t-il vraiment s'ouvrir ?
  const popupWillAppear = !(localStorage.getItem('theme:popup-filled') === 'true'
    || (signupCardEl.hasAttribute('only-once') && localStorage.getItem('theme:popup-appeared') === 'true'));
  if (popupWillAppear) {
    document.documentElement.classList.add('am-intro-hold');
    const releaseIntro = () => {
      if (!document.documentElement.classList.contains('am-intro-hold')) return;
      document.documentElement.classList.remove('am-intro-hold');
      heroIntroEls.forEach((el) => {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      });
    };
    signupCardEl.addEventListener('dialog:before-hide', releaseIntro);
    // Filet de sécurité : si le popup ne s'ouvre pas, l'intro part quand même
    setTimeout(() => {
      if (!signupCardEl.hasAttribute('open')) releaseIntro();
    }, 4000);
    // Garde-fou bloqueur de pub : popup ouvert mais rendu invisible de force
    // (display none injecté) → on libère l'intro, sinon elle resterait gelée
    const signupWatchdog = setInterval(() => {
      if (!document.documentElement.classList.contains('am-intro-hold')) {
        clearInterval(signupWatchdog);
        return;
      }
      const style = getComputedStyle(signupCardEl);
      if (signupCardEl.hasAttribute('open') && (style.display === 'none' || style.visibility === 'hidden')) {
        clearInterval(signupWatchdog);
        releaseIntro();
      }
    }, 1500);
  }
}

// Galerie clients : apparition échelonnée au scroll + visionneuse avec
// navigation (flèches, clavier, légende). Sans JS ou en motion réduit,
// la grille est simplement visible (état géré par la classe am-js en CSS).
document.documentElement.classList.add('am-js');
const galerieItems = Array.from(document.querySelectorAll('.galerie-clients__item'));
if (galerieItems.length) {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    galerieItems.forEach((item, index) => {
      item.style.setProperty('--reveal-delay', `${(index % 4) * 90}ms`);
      revealObserver.observe(item);
    });
  }

  const galerieImages = galerieItems
    .map((item) => item.querySelector('.galerie-clients__img'))
    .filter(Boolean);

  if (galerieImages.length) {
    const overlay = document.createElement('div');
    overlay.className = 'am-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Photo agrandie');
    overlay.hidden = true;
    overlay.innerHTML = '<button type="button" class="am-lightbox__nav am-lightbox__nav--prev" aria-label="Photo précédente">‹</button>'
      + '<figure><img alt=""><figcaption></figcaption></figure>'
      + '<button type="button" class="am-lightbox__nav am-lightbox__nav--next" aria-label="Photo suivante">›</button>';
    document.body.appendChild(overlay);
    const overlayImg = overlay.querySelector('img');
    const overlayCaption = overlay.querySelector('figcaption');
    let galerieIndex = 0;

    const largestSource = (img) => {
      if (!img.srcset) return img.currentSrc || img.src;
      return img.srcset.split(',').map((entry) => {
        const [url, size] = entry.trim().split(/\s+/);
        return { url, w: parseInt(size) || 0 };
      }).sort((a, b) => b.w - a.w)[0].url;
    };

    const showGalerieImage = (index) => {
      galerieIndex = (index + galerieImages.length) % galerieImages.length;
      const img = galerieImages[galerieIndex];
      overlayImg.src = largestSource(img);
      overlayImg.alt = img.alt || '';
      const item = img.closest('.galerie-clients__item');
      overlayCaption.textContent = item?.dataset.handle || '';
      if (item?.dataset.legende) {
        const legende = document.createElement('span');
        legende.className = 'am-lightbox__legende';
        legende.textContent = item.dataset.legende;
        overlayCaption.appendChild(legende);
      }
    };

    const closeGalerie = () => {
      overlay.hidden = true;
      document.documentElement.classList.remove('am-lightbox-open');
    };

    galerieImages.forEach((img, index) => {
      img.closest('.galerie-clients__media').addEventListener('click', (event) => {
        if (event.target.closest('.galerie-clients__caption a')) return;
        showGalerieImage(index);
        overlay.hidden = false;
        document.documentElement.classList.add('am-lightbox-open');
      });
    });

    overlay.addEventListener('click', closeGalerie);
    overlay.querySelectorAll('.am-lightbox__nav').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        showGalerieImage(galerieIndex + (btn.classList.contains('am-lightbox__nav--next') ? 1 : -1));
      });
    });
    document.addEventListener('keydown', (event) => {
      if (overlay.hidden) return;
      if (event.key === 'Escape') closeGalerie();
      if (event.key === 'ArrowRight') showGalerieImage(galerieIndex + 1);
      if (event.key === 'ArrowLeft') showGalerieImage(galerieIndex - 1);
    });
  }
}

// Galerie clients : boucle du slider. Arrivé au bout, la flèche suivante
// revient au début (et la précédente, au début, file à la fin). Les flèches
// restent toujours actives : on annule le disabled posé par le thème aux bords.
const galerieSlider = document.querySelector('.galerie-clients__slider');
if (galerieSlider) {
  const galerieWrap = galerieSlider.closest('.galerie-clients');
  const arrowButtons = galerieWrap.querySelectorAll('.prev-next-button');
  const keepArrowsActive = () => arrowButtons.forEach((btn) => btn.removeAttribute('disabled'));
  keepArrowsActive();
  new MutationObserver(keepArrowsActive).observe(galerieWrap, { subtree: true, attributes: true, attributeFilter: ['disabled'] });

  const maxScroll = () => galerieSlider.scrollWidth - galerieSlider.clientWidth;
  galerieWrap.querySelector('.prev-next-button--next')?.addEventListener('click', (event) => {
    if (galerieSlider.scrollLeft < maxScroll() - 4) return;
    event.stopPropagation();
    galerieSlider.scrollTo({ left: 0, behavior: 'smooth' });
  });
  galerieWrap.querySelector('.prev-next-button--prev')?.addEventListener('click', (event) => {
    if (galerieSlider.scrollLeft > 4) return;
    event.stopPropagation();
    galerieSlider.scrollTo({ left: maxScroll(), behavior: 'smooth' });
  });
}
